import FloorPlanTable from "@/app/app-shared/floor-plan/table";

export default function FloorPlanPage() {
    return <FloorPlanTable />;
}
